import styled from 'styled-components';

export const LoaderWrapper = styled.div`
    display:flex;
    width:100vw;
    height:80vh;
    justify-content: center;
    align-items: center;
`;